import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {action} from 'mobx';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';
import { BOOKING_BASE_URL } from 'utils/constants';

import Button from '@urbanmassage/component-library/lib/Button/Button';

import ProgressiveImage from 'spa/Components/ProgressiveImage';
import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';

import 'spa/styles/home.less';
import '../../Home/HomeOverviewSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeOverviewSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickBook - HomeOverviewSectionForDigital')
  onClickBook() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Book Now',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Book Now button', trackingData);
  }

  render() {
    const {i18n} = this.context;
    const {
      screen: {
        isDesktop,
      },
    } = this.props;

    return (
      <div
        className="home-overview-section home-content-section row"
        data-testid="home-overview-section-container"
      >
        <div className="home-content-section__cell home-content-section__cell-text home-content-section-for-digital__cell-text home-content-section--pull-bottom">
          <div className="home-content-section__text-content">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('How it works', 'Home overview section title')}</h2>

            <ul className="home-content-section__list">
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('Pick a treatment', 'Home overview section list title')}</h4>
                {i18n.umRegion === 'FR' ? (
                  <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">
                    {i18n._x('With a choice of over 10 massage and osteopathy treatments for relaxation, energy and balance.', 'Home overview section description')}
                  </p>
                ) : (
                  <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">
                    15+ styles of massage, plus at-home beauty, physiotherapy and osteopathy
                  </p>
                )}
              </li>
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('Choose your therapist', 'Home overview section list title')}</h4>
                {i18n.umRegion === 'FR' ? (
                  <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">{i18n._x('Browse profiles of qualified, insured and pre-vetted pros who’ll bring everything needed for your treatment.', 'Home overview section description')}</p>
                ) : (
                  <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">Browse profiles of qualified, insured and pre-vetted pros</p>
                )}

              </li>
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('Set a time and place', 'Home overview section list title')}</h4>
                <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">{i18n._x('Anywhere in the city, any day, 7am-11pm', 'Home overview section description')}</p>
              </li>
            </ul>
            <div
              className="home-content-section__button home-content-section-for-digital__button"
              data-qa="home-services-section-digital-button"
              data-testid="home-overview-section-container-button-wrapper"
            >
              <Button
                onClick={this.onClickBook}
                href={`/${i18n.lc}/${BOOKING_BASE_URL}/`}
              >
                {i18n._x('Book at home', 'Homepage book now button')}
              </Button>
            </div>
          </div>
        </div>
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-overview-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644311097/b2c-art/home-2022/home-second.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_1440/v1644311097/b2c-art/home-2022/home-second.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644311097/b2c-art/home-2022/home-second.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-overview-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644311097/b2c-art/home-2022/home-second.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/f_auto,w_1440/v1644311097/b2c-art/home-2022/home-second.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644311097/b2c-art/home-2022/home-second.jpg"
            />
          )}
        </ProgressiveBackgroundImage>
      </div>
    );
  }
}

export default HomeOverviewSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeOverviewSectionForDigital.jsx